import Consts from '@/common/consts'
export default {
  BIND_TB_CHECK: `${Consts.API_HOST_MAIN}/adTbk/checkBind`, // 检查是否绑定淘宝账号
  BIND_TB: `${Consts.API_HOST_MAIN}/adTbk/bind`, // 绑定淘宝账号

  HOT_SEARCH: `${Consts.API_HOST_MAIN}/adTbk/qryHotKw`, // 热门搜索
  SEARCH: `${Consts.API_HOST_MAIN}/adTbk/searchGoodsBykw`, // 搜索
  SEARCH_KW_CATE_GOODS: `${Consts.API_HOST_MAIN}/adTbk/querySecKwGoods`, // 搜索关键字分类商品

  TAB_LIST: `${Consts.API_HOST_MAIN}/adTbk/qryTab`, // tab菜单
  TAB_SLIDE_LIST: `${Consts.API_HOST_MAIN}/adTbk/qrySlide`, // tab菜单对应的轮播
  TAB_CATE_LIST: `${Consts.API_HOST_MAIN}/adTbk/qryCate`, // tab菜单对应的分类
  TAB_CATE_ALL_LIST: `${Consts.API_HOST_MAIN}/adTbk/qryCateAll`, // tab菜单对应的完整分类
  SUB_CATE_LIST: `${Consts.API_HOST_MAIN}/adTbk/qrySubCate`, // 三级分类列表

  CHOICE_GOODS_LIST: `${Consts.API_HOST_MAIN}/adTbk/qryChoiceGoods`, // 好货优选
  RECOMMEND_GOODS_LIST: `${Consts.API_HOST_MAIN}/adTbk/qryRecommendGoods`, // 为你推荐
  TAB_GOODS_LIST: `${Consts.API_HOST_MAIN}/adTbk/qryTabGoods`, // tab菜单对应的商品列表
  SLIDE_GOODS_LIST: `${Consts.API_HOST_MAIN}/adTbk/qrySlideGoods`, // 轮播图对应的商品列表
  CATE_GOODS_LIST: `${Consts.API_HOST_MAIN}/adTbk/qryCateGoods`, // 分类对应的商品列表

  GOODS_DETAIL: `${Consts.API_HOST_MAIN}/adTbk/queryAdGoodsDetail`, // 商品详情
  TB_GOODS_DETAIL: `${Consts.API_HOST_TB}/mtop.taobao.detail.getdetail/6.0`, // 淘宝商品详情
  TB_GOODS_DESC: `${Consts.API_HOST_TB}/mtop.taobao.detail.getdesc/6.0`, // 淘宝商品详情
  GET_TB_TKL: `${Consts.API_HOST_MAIN}/adTbk/qryTpwd`, // 获取淘口令
  SAVE_SEARCH_GOODS_DETAIL: `${Consts.API_HOST_MAIN}/adTbk/saveSearchGoodsDetail`, // 保存商品详情(搜索之后分享)
  QUERY_SEARCH_GOODS_DETAIL: `${Consts.API_HOST_MAIN}/adTbk/querySearchGoodsDetail`, //  商品详情(搜索的商品分享后的链接)

  MARK_PRODUCT: `${Consts.API_HOST_MAIN}/adTbk/addCollection`, // 收藏商品
  UNMARK_PRODUCT: `${Consts.API_HOST_MAIN}/adTbk/delCollectionByGoodsId`, // 取消收藏商品
  UNMARK_PRODUCT_BY_IDS: `${Consts.API_HOST_MAIN}/adTbk/delCollectionByIds`, // 批量移除收藏的商品
  MARKED_PRODUCT_LIST: `${Consts.API_HOST_MAIN}/adTbk/qryCollectionList`, // 收藏的商品列表

  BEAN_BALANCE: `${Consts.API_HOST_MAIN}/adTbk/qryTbkGoldenBeans`, // 金豆合计
  BEAN_LIST: `${Consts.API_HOST_MAIN}/adTbk/qryTbkGoldenBeansList`, // 金豆列表
  SETTLED_PROFIT_BALANCE: `${Consts.API_HOST_MAIN}/adTbk/qryTbkCommissionEnrolled`, // 已结算收益合计
  SETTLED_PROFIT_LIST: `${Consts.API_HOST_MAIN}/adTbk/qryTbkCommissionEnrolledList`, // 已结算收益列表
  UNSETTLED_PROFIT_BALANCE: `${Consts.API_HOST_MAIN}/adTbk/qryTbkCommissionUnbooked`, // 待结算收益合计
  UNSETTLED_PROFIT_LIST: `${Consts.API_HOST_MAIN}/adTbk/qryTbkCommissionUnbookedList`, // 待结算收益列表
  
  ORDER_LIST: `${Consts.API_HOST_MAIN}/adTbk/qryOrders`, // 我的订单
  TEAM_ORDER_LIST: `${Consts.API_HOST_MAIN}/adTbk/qryTeamOrders`, // 团队订单
  QUERY_UNBIND_TB_ORDER: `${Consts.API_HOST_MAIN}/adTbk/qryNoBindOrder`, // 查询未绑定订单
  BIND_TB_ORDER: `${Consts.API_HOST_MAIN}/adTbk/bindOrder`, // 绑定订单
}
